import q1 from './q1.json';
import q2 from './q2.json';
import q3 from './q3.json';
import q4 from './q4.json';
import q5 from './q5.json';
import q6 from './q6.json';
import q7 from './q7.json';
import q8 from './q8.json';
import stay from './intro.json';
import ce from './ce.json';

export const animationData = { q1, q2, q3, q4, q5, q6, q7, q8 };
export const intro = stay;
export const introCentered = ce;